import React from "react";
import "./RangeSelector.css";

function RangeSelector({ weapon, onSelect, onClose }) {
  // Estrai le gittate e i danni
  const ranges = weapon.range.split("/");
  const damages = weapon.damage.split("/");

  const handleSelectRange = (rangeIndex) => {
    onSelect({
      range: ranges[rangeIndex],
      damage: damages[rangeIndex],
    });
  };

  return (
    <div className="range-selector-overlay" onClick={onClose}>
      <div
        className="range-selector-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="range-selector-header">
          <h3>Seleziona Distanza per {weapon.name}</h3>
          <button className="range-selector-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="range-selector-content">
          <p className="range-selector-description">
            A quale distanza stai sparando?
          </p>
          <div className="range-selector-options">
            {ranges.map((range, index) => (
              <button
                key={index}
                className="range-selector-option"
                onClick={() => handleSelectRange(index)}
              >
                <div className="range-option-distance">{range} metri</div>
                <div className="range-option-damage">
                  Danno: {damages[index]}
                </div>
              </button>
            ))}
          </div>
        </div>

        <div className="range-selector-footer">
          <button className="range-selector-cancel" onClick={onClose}>
            Annulla
          </button>
        </div>
      </div>
    </div>
  );
}

export default RangeSelector;
